import React from "react";
import { Link } from "react-router";
import { Button, Icon } from "semantic-ui-react";
import Flagship from "../../core/flagship";

const NotFoundPage = () => {
  // Try to redirect "old flagship" links
  if (
    window.location.pathname.includes("wp-admin/admin.php") &&
    window.location.search.includes("page=view-") &&
    window.location.search.includes("view=")
  ) {
    let urlParams = new URLSearchParams(window.location.search);
    let view = urlParams.get("view");

    Flagship.get("record/id/" + "99" + view, {}, function(response) {
      if (response.status === 200 && response.data.hasOwnProperty("link")) {
        Flagship.redirect(response.data.link);
      } else {
        // If newest ID fails, try older form
        Flagship.get("record/id/" + "9" + view, {}, function(response) {
          if (response.status === 200 && response.data.hasOwnProperty("link")) {
            Flagship.redirect(response.data.link);
          } else {
            // If newer ID fails, try even older form
            Flagship.get("record/id/" + view, {}, function(response) {
              if (
                response.status === 200 &&
                response.data.hasOwnProperty("link")
              ) {
                Flagship.redirect(response.data.link);
              }
            });
          }
        });
      }
    });
  }
  document.title = "Flagship / Error";
  return (
    <div>
      <div id="view-header-section">
        <h1 className="view-title">Oops, something went wrong!</h1>
        <p className="white-text">
          This feature is either broken or coming soon.
        </p>
      </div>
      <br />
      <Button as={Link} to="/" className="back-to-dash">
        <Icon name="left arrow" />
        Back to Dashboard
      </Button>
    </div>
  );
};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/views/NotFoundPage.js